<template>
  <div class="container">
    <div v-if="$store.state.preguntas == ''">
      <h3>El candidato aun no cuenta con el diagnóstico</h3>
    </div>

    <div v-if="$store.state.preguntas != ''">
      <p v-if="$store.state.cuestionario.anuncio != ''">
        El candidato sobrepaso el tiempo límite para realizar su diagnóstico
      </p>

      <p>
        <b>Fecha en que se realizó: </b
        >{{ $store.state.cuestionario.fecha_respuesta }}
      </p>

      <div v-for="items in preguntasPreguntas" :key="items.id">
        <!-- mensajes -->
        <blockquote
          v-if="
            preguntas[items].pregunta1.numeropreg == 1 &&
            preguntas[items].pregunta1.parte == 1
          "
        >
          PRIMERA SECCIÓN: SONDEO
        </blockquote>
        <blockquote
          v-if="
            preguntas[items].pregunta1.numeropreg == 1 &&
            preguntas[items].pregunta1.parte == 2
          "
        >
          SEGUNDA SECCIÓN: TEORÍA TECNOPEDAGÓGICA
        </blockquote>
        <blockquote
          v-if="
            preguntas[items].pregunta1.numeropreg == 1 &&
            preguntas[items].pregunta1.parte == 3
          "
        >
          TERCERA SECCIÓN: CONOCIMIENTO Y EXPERIENCIA EN EL USO DE NUEVAS
          TECNOLOGÍAS APLICADAS A LA EDUCACIÓN
        </blockquote>
        <blockquote
          v-if="
            preguntas[items].pregunta1.numeropreg == 1 &&
            preguntas[items].pregunta1.parte == 4
          "
        >
          CUARTA SECCIÓN: NOCIONES BÁSICAS DE METODOLOGÍA DE INVESTIGACIÓN
        </blockquote>
        <!-- mensajes  -->
        <p class="pregunta textopregunta">
          <b>Pregunta {{ preguntas[items].pregunta1.pregunta }}</b>
        </p>

        <div
          class="cuestionario parrafo"
          v-for="item in preguntas[items].pregunta1.respuestas"
          :key="item.id"
        >
          <p>
            <label>
              <input
                disabled="disabled"
                :name="`grupo${items}`"
                type="radio"
                @click="opcion(item, items)"
                :value="item"
                v-model="preguntas[items].pregunta1.seleccion"
              />
              <span class="letrapreg">{{ item }}</span>
            </label>
          </p>
          <!-- aqui {{ preguntas[items].pregunta1.retro.respuesta[item] }} -->
        </div>
        <div
          class="cuestionario parrafo"
          v-for="item in preguntas[items].pregunta1.respuestas"
          :key="item.id"
        >
          <p v-if="preguntas[items].pregunta1.retro">
            <b
              :class="[
                preguntas[items].pregunta1.correcta ==
                preguntas[items].pregunta1.seleccion
                  ? 'verde'
                  : 'morado',
              ]"
              v-if="item == preguntas[items].pregunta1.seleccion"
              >Respuesta:
              {{ preguntas[items].pregunta1.retro.respuesta[item] }}</b
            >
            <!-- Retro {{ preguntas[items].pregunta1.retro.respuesta[item] }} -->
          </p>
        </div>
      </div>
      <!-- <div class="center">
        <button
          class="btn orange"
          @click="() => this.$store.commit('setContadorMenosNumero', 2)"
        >
          Regresar
        </button>
      </div> -->
      <div class="center row">
        <div class="col s1 s1"></div>

        <div class="col s4 s4">
          <button class="btn orange" @click="descargar()">
            Descargar resultados
          </button>
        </div>
        <div class="col s2 s2"></div>
        <div class="col s4 s4">
          <!-- <button
            class="btn blue"
            href="documentos/Lecturas Retroalimentación DiagnosticoMCyTE2021.zip"
            download
          >
            Descargar lecturas
          </button> -->
          <a
            href="documentos/Lecturas Retroalimentación DiagnosticoMCyTE2021.zip"
            download
            class="btn blue"
          >
            Descargar Lecturas
            <!-- <i class="material-icons">cloud_download</i> -->
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      preguntasPreguntas: [],
      preguntas: [],
      // preg: 0,
      respuestas: [],
      result: 0,
    };
  },
  methods: {
    async descargar() {
      try {
        let x = await this.$store.dispatch("imprimirPDF");
        if (x == "ok") {
          this.$store.dispatch("descargarPDF");
          // swal("", "Los datos se guardaron correctamente", "success");
        }
      } catch (error) {
        console.log(error);
      }
    },
    descargarL() {},
  },
  mounted() {
    M.AutoInit();
  },
  async created() {
    await this.$store.dispatch("cargaCuestionario");
    this.preguntas = this.$store.state.preguntas;
    // console.log(this.preguntas);
    let x = this.preguntas.length;
    for (let index = 0; index < x; index++) {
      this.preguntasPreguntas.push(index);
    }
  },
};
</script>
<style  scoped>
.letrapreg {
  color: black !important;
}
.verde {
  color: green;
}
.morado {
  color: purple;
}
</style>
